import { AggregateMaterialEnum } from "@/domain/models/common";

export const TASK_TIME_DURATION = 90;

export const AGGREGATE_MATERIAL_LIST = [
  { material: AggregateMaterialEnum.CLEAR_LIMESTONE, unitPrice: 50 },
  { material: AggregateMaterialEnum.LIMESTONE_CRUSH, unitPrice: 40 },
  { material: AggregateMaterialEnum.HPB_LIMESTONE, unitPrice: 44 },
  { material: AggregateMaterialEnum.LIMESTONE_SCREENING, unitPrice: 37 },
  { material: AggregateMaterialEnum.PEA_STONE_GRAVEL, unitPrice: 62 },
  { material: AggregateMaterialEnum.RIVER_STONE_GRAVEL, unitPrice: 75 },
  { material: AggregateMaterialEnum.BRICK_SAND, unitPrice: 41 },
  { material: AggregateMaterialEnum.CONCRETE_SAND, unitPrice: 41 },
  { material: AggregateMaterialEnum.STOCK_PILE_SOIL, unitPrice: 18 },
  { material: AggregateMaterialEnum.SCREENED_TOPSOIL, unitPrice: 30 },
  { material: AggregateMaterialEnum.TRIPLE_MIX_SOIL, unitPrice: 55 },
  { material: AggregateMaterialEnum.GROW_MAX_SOIL, unitPrice: 67 },
  { material: AggregateMaterialEnum.SHREDDED_PINE_MULCH, unitPrice: 62 },
  { material: AggregateMaterialEnum.BLACK_BEAUTY_MULCH, unitPrice: 62 },
  { material: AggregateMaterialEnum.CLEAN_CONCRETE, unitPrice: 25 },
  { material: AggregateMaterialEnum.MIX_BRICK, unitPrice: 30 },
  { material: AggregateMaterialEnum.ASPHALT, unitPrice: 35 },
];

export const GOOGLE_MAP_BASE_URL = `https://www.google.com/maps?daddr=`;

export const TURNAROUND_FEE_NOTE =
  "Turnaround fee to be applied to the final invoice";
